import { render, staticRenderFns } from "./RegulatoryStatement.vue?vue&type=template&id=687a2bc8&scoped=true"
import script from "./RegulatoryStatement.vue?vue&type=script&lang=js"
export * from "./RegulatoryStatement.vue?vue&type=script&lang=js"
import style0 from "./RegulatoryStatement.vue?vue&type=style&index=0&id=687a2bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a2bc8",
  null
  
)

export default component.exports